import { atom, useAtom } from 'jotai';

const sidebarOpenAtom = atom<boolean>(false);

export const useSidebarOpen = () => {
  const [isDropdownOpen, setDropdownOpen] = useAtom(sidebarOpenAtom);

  return {
    isDropdownOpen,
    setDropdownOpen,
  };
};
